import React, { useState, useEffect } from 'react';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Pagination from '@mui/material/Pagination';
import Grid from '@mui/material/Grid';
import LaunchIcon from '@mui/icons-material/Launch';
import IconButton from '@mui/material/IconButton';

import { BrowserView, MobileView, isDesktop, isMobile } from 'react-device-detect';

import { LocalizationContext } from '../App';


import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import TranslateIcon from '@mui/icons-material/Translate';

import { Button as RoundedButton } from 'grommet';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

const HelpComponentLocalActivities = (props) => {

    const [ currentPage, setCurrentPage ] = useState(1);
    
    const handlePaginationChange = (event, value) => {
        setCurrentPage(value);        
    };

    const bg = ('light' == 'light') ? "#ffffff66" : "#12121266";

    return (
        <LocalizationContext.Consumer>

        { ({strings}) => (

            <React.Fragment>

                <Box sx={{ height : '100%', width : '100%' }}>                        
                    
                    <Box sx={{ 
                        height : '100%',
                        display : 'flex', 
                        flexFlow : 'column' }}>
                        
                        <Stack 
                            direction="column" 
                            sx={{ overflow : 'auto', flex : "1 1 auto"}}>


                            <Typography className="mb-4" variant="overline" gutterBottom>
                                {strings.getString("help.localactivities.title")}
                            </Typography>


                            {currentPage == 1 &&
                                <>
                                    <Typography variant="body2" gutterBottom>
                                        {strings.getString("help.localactivities.parai")}
                                    </Typography>
                                    
                                </>
                            }

                            {currentPage == 2 &&
                                <>
                                    <Typography variant="subtitle1" gutterBottom>
                                        {strings.getString("help.localactivities.headu1")}
                                    </Typography>
                                    <p />
                                    <Typography variant="body2" gutterBottom>
                                        {strings.getString("help.localactivities.parau1")}
                                    </Typography>
                                    <p />
                                    <Stack direction={ 'row' } justifyContent="center">
                                        <RoundedButton
                                            active={false}
                                            color="#e3165b" 
                                            label={
                                                <>
                                                    <Stack direction="row">
                                                        <GpsFixedIcon color="primary"/>                                                                                                                                                                                                   
                                                    </Stack>                                                                                                                        
                                                </>
                                            }>
                                        </RoundedButton>
                                    </Stack>
                                    <p />
                                    <Typography variant="body2" gutterBottom>
                                        {strings.getString("help.localactivities.parau2")}
                                    </Typography>
                                    <p />
                                    
                                </>
                            }

                            {currentPage == 3 &&
                                <>
                                    <Typography variant="subtitle1" gutterBottom>
                                        {strings.getString("help.localactivities.headl1")}
                                    </Typography>
                                    <p />
                                    <Stack direction={ 'row' } justifyContent="center">
                                        <RoundedButton  
                                            style={{ margin : '10px' }}
                                            active={false}                                    
                                            color="#e3165b" 
                                            label={
                                                <>
                                                    <Stack direction="row">
                                                        <TranslateIcon className="padright" color="primary"/>
                                                        <Typography color="primary" variant="body2">
                                                            {strings.getString("controls.buttons.activity.language.selection")}
                                                        </Typography>                                                                                                                                
                                                    </Stack>                                                                                                                        
                                                </>
                                            }>
                                        </RoundedButton> 
                                    </Stack>
                                    <p />
                                    <Typography variant="body2" gutterBottom>
                                        {strings.getString("help.localactivities.paral1")}
                                    </Typography>
                                    
                                </>
                            }

                            {currentPage == 4 &&
                                <>
                                    <Typography variant="subtitle1" gutterBottom>
                                        {strings.getString("help.localactivities.heada1")}
                                    </Typography>
                                    <p />
                                    <Typography variant="body2" gutterBottom>
                                        {strings.getString("help.localactivities.paraa1")}
                                    </Typography>
                                    <p />
                                    <Stack direction={ 'row' } justifyContent="center">
                                        <IconButton edge="end" aria-label="comments">
                                            <LaunchIcon />
                                        </IconButton>
                                    </Stack>
                                    <p />
                                    <Typography variant="body2" gutterBottom>
                                        {strings.getString("help.localactivities.paraa2")}
                                    </Typography>
                                    
                                </>
                            }

                            

                        </Stack>

                        <Pagination  
                            sx={{ flex : "0 1 auto", marginTop : "auto" }}                           
                            variant="outlined" 
                            color="primary" 
                            className="container" 
                            count={4} 
                            page={currentPage} 
                            onChange={handlePaginationChange} />

                    </Box>
                    

                </Box>

            </React.Fragment>
        
        )}

        </LocalizationContext.Consumer>
    )

}
export default HelpComponentLocalActivities;